import styles from "./allDataFilterPopup.module.css";
import Header from "components/header/Header";
import LogedinHeaderComponent from "components/logedinHeaderComponent/logedinHeaderComponent";
import Popup from "components/Popup/popup";
import { useState } from "react";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { downloadAllData } from "utils/statistic";
import ErrorFailed from "components/errorFailed/errorFailed";

interface AllDataFilterPopupProps {
    isPopupOpen: boolean;
    onClose: () => void;
}

export default function AllDataFilterPopup({ isPopupOpen, onClose }: AllDataFilterPopupProps) {

    const [error, setError] = useState<string | null>(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isAllDataChecked, setIsAllDataChecked] = useState(false);

    const handleClose = () => {
        setStartDate("");
        setEndDate("");
        setError(null);
        setIsAllDataChecked(false);
        onClose();
    };

    const handleSubmit = () => {
        if (!isAllDataChecked) {
            if (!startDate || !endDate) {
                setError("Bitte geben Sie sowohl ein Start- als auch ein Enddatum ein.");
                return;
            }
            if (new Date(startDate) > new Date(endDate)) {
                setError("Das Startdatum darf nicht nach dem Enddatum liegen.");
                return;
            }
        }
        downloadAllData(startDate, endDate)

        handleClose();
    };

    if (!isPopupOpen) {
        return null;
    }

    return (
        <Popup
            title={'Filter'}
            submitLabel={"Herunterladen"}
            closeLabel={"Abbrechen"}
            isWithButton={true}
            isOpen={isPopupOpen}
            onClose={handleClose}
            onSubmit={handleSubmit}>
            {error && <ErrorFailed error={error} />}

            <div className={styles.checkboxContainer}>
                <input
                    type="checkbox"
                    id="allData"
                    name="allData"
                    checked={isAllDataChecked}
                    onChange={(e) => setIsAllDataChecked(e.target.checked)}
                />
                <label htmlFor="allData">
                    alle Daten aus allen Zeiträumen herunterladen.
                </label>
            </div>

            {!isAllDataChecked && (
                <div className={commonStyles.formGroupRow}>
                    <div className={commonStyles.formGroup}>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>
                    <div className={commonStyles.formGroup}>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                </div>
            )}
        </Popup>
    );
}
